import config from '../config';
import apiClient from './apiClient';

const getBonusDraw = async() => {
  try {
    const response = await apiClient.get(
      `${config.API_BASE_URL}/bonusDraw/getActive`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
}

export {getBonusDraw};
